import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setRegularization } from "../store/reducers/regularizationSlice";

import Calendar from "../Components/Regularization/Calender";
import RegularizationPanel from "../Components/Regularization";
import ConfirmationDialog from "../Components/Regularization/ConfirmationDialog";
import { getToken, setToken } from "../services/Token";
import { getMonthStartAndEndDates } from "../utils";
import { useFetchRegularizationStatusMutation } from "../api/regularizationApi";
import { getDayName } from "../calenderUtils";
import { toast } from "react-toastify";

const ApplyRegularization = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [regularizations, setRegularizations] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { statuses, regularizationEmployeeId } = useSelector((state) => state.regularization);
  const role = getToken('roles');
  const isAdmin = role ? role.includes("ADMIN") : false;
  const employeeId = isAdmin ? regularizationEmployeeId : getToken("Id");
  const [fetchRegularizationStatus] = useFetchRegularizationStatusMutation();
  const { startDate, endDate } = getMonthStartAndEndDates();
  const dispatch = useDispatch();
  useEffect(() => {
    setRegularizations([]);
    setCurrentDate(new Date());
    dispatch(setRegularization({ cc: [], remarks: "", entries: [] }));
  }, [employeeId, dispatch]);

  useEffect(() => {
    if (employeeId && startDate && endDate) {
      setToken('fromDate',startDate)
      setToken('toDate',endDate)
      const body = {
        employeeId: employeeId,
        fromDate: startDate,
        toDate: endDate,
      };
      fetchRegularizationStatus(body);
    }
  }, [employeeId, startDate, endDate, fetchRegularizationStatus]);

  const handleAddDate = (date) => {
    const dayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const dayName = getDayName(currentDate, date, dayNames);
    const newId = Math.max(...regularizations.map((r) => r.id), 0) + 1;
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth(); // 0-indexed
    const dateObj = new Date(year, month, date);
    const formattedDate = dateObj.toLocaleDateString("en-CA");
    const newRegularization = {
      id: newId,
      date: date,
      formattedDate: formattedDate,
      day: dayName,
      shift: "General Shift 01",
      fromTime: "",
      toTime: "",
      fromPeriod: "",
      toPeriod: "",
      reason: "",
      isOriginal: false,
      remarks: "",
    };

    const isDateRecordThere = regularizations.some(r => r.date === date);
    if (isDateRecordThere) {
        toast.error("Date already added");
        return;
    }
    setRegularizations([...regularizations, newRegularization]);
};

  const handleRemoveRegularization = (id) => {
    setRegularizations(regularizations.filter((reg) => reg.id !== id));
  };

  const handleNavigateMonth = async (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
    const formattedDate = newDate.toDateString();
    const inputDate = new Date(formattedDate);
    const year = inputDate?.getFullYear();
    const month = inputDate?.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const formatDate = (date) => date.toLocaleDateString("en-CA");
    setRegularizations([]);
    setToken('fromDate',formatDate(firstDay))
    setToken('toDate',formatDate(lastDay))
    try {
      const body = {
        employeeId: employeeId,
        fromDate: formatDate(firstDay),
        toDate: formatDate(lastDay),
      };
      await fetchRegularizationStatus(body).unwrap();
    } catch (error) {
      toast.error(error?.data?.message);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", px: 2 }}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Calendar
          date={currentDate}
          onNavigateMonth={handleNavigateMonth}
          onAddDate={handleAddDate}
          regularizations={regularizations}
          statuses={statuses}
        />

        <RegularizationPanel
          regularizations={regularizations}
          onRemoveRegularization={handleRemoveRegularization}
          setRegularizations={setRegularizations}
        />
      </Box>

      <ConfirmationDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={handleNavigateMonth}
        title="Are You Sure?"
        message="Are you sure you want to navigate to another month? All the unsaved changes will be lost."
      />
    </Box>
  );
};

export default ApplyRegularization;
